import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import Golf from '../models/Golf';

const initialState = {
    isFetching: false,
    isFetched: false,
    golfs: [],
    allGolfs: [],
    pageSize: PAGINATION.pageSize,
    pageNumber: PAGINATION.pageNumber,
    totalCount: PAGINATION.totalCount,
    detail: {
        golf: new Golf()
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.GOLF_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.GOLF_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                golfs: action.golfs.result,
                pageSize: action.golfs.pageSize,
                pageNumber: action.golfs.pageNumber,
                totalCount: action.golfs.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.GOLF_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, golfs: [] };
        case Types.GOLF_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.GOLF_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: { golf: action.golf, }
            };
        case Types.GOLF_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.GOLF_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.GOLF_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        default: 
            return state
    }
}
